import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EntiService {
  private _enti: BehaviorSubject<number> = new BehaviorSubject(null);
  enti$ = this._enti.asObservable();

  constructor(private http: HttpClient) { }

  public getList(page: number, size: number, sort: string, filters?: ModelEventiCalamitosi.EnteSearchableDto) {
    let searchParams = new HttpParams();
    searchParams = searchParams.append('page', `${page}`);
    searchParams = searchParams.append('size', `${size}`);
    searchParams = searchParams.append('sort', `${sort}`);
    for (let key in filters) {
      if (filters[key] !== null && filters[key] !== undefined && filters[key].toString().trim() !== '') {
        searchParams = searchParams.append(key, filters[key]);
      }
    }

    return this.http
      .get<ModelEventiCalamitosi.EnteDto[]>(`${environment.urls.base}/template/ente/list`,
        {
          params: searchParams
        }
      );
  }

  // Controlla se l'ente è abilitato alla raccoltra/correzione per uno specifico template
  public checkPermessiEELLperSegnalazione(codiceSegnalazione: number) {
    return this.http
      .get<ModelEventiCalamitosi.AbilitazioniEnteSuSegnalazione>(`${environment.urls.base}/template/ente/ente-abilitato-correzione-compilazione-segnalazione/${codiceSegnalazione}`);
  }

  // controlla se è abilitato alla raccolta/correzione di almeno 1 template dell'evento
  public getEnteAbilitatoAlmenoAdUnTemplatePerEvento(idEvento: number) {
    return this.http
      .get<ModelEventiCalamitosi.EnteAbilitatoPerEventoDto>(`${environment.urls.base}/template/ente/check-ente-abilitato-correggere-aggiungere/${idEvento}`);
  }

  public getEntiProfilatiList() {
    return this.http
      .get<ModelEventiCalamitosi.EnteDto[]>(`${environment.urls.base}/template/ente/list-enti-profilati`);
  }

  public changeStatoEnte(enteDto: ModelEventiCalamitosi.AnaDatiRaccoltiDTO) {
    return this.http
      .post<ModelEventiCalamitosi.EnteDto>(
        `${environment.urls.base}/template/ente/cambia-stato`,
        enteDto,
        {
          observe: 'response'
        }
      );
  }

  public modificaStatoCompilazione(compilazioneEntiDto: ModelEventiCalamitosi.ModStatoCompilazioneEntiDto) {
    return this.http.post<ModelEventiCalamitosi.EnteDto[]>(
      `${environment.urls.base}/template/ente/modifica-stato-compilazione`,
      compilazioneEntiDto,
      {
        observe:
          'response'
      });
  }

  showEnte(idEnte: number) {
    this._enti.next(idEnte);
  }

  /**
  * Chiama il backend per l'invio delle notifiche AppIO.
  * Restituisce EsitoNotificaDTO per la gestione dei messaggi a FE.
  */
  public inviaNotificaAppIO(compilazioneEntiDto: ModelEventiCalamitosi.ModStatoCompilazioneEntiDto) {
    return this.http.post<ModelEventiCalamitosi.EsitoNotificaDTO>(
      `${environment.urls.base}/evento/invio-notifica-appio`,
      compilazioneEntiDto
    );
  }

}
